import { apiGet, apiPost, apiDelete } from '../api';
import { HOST } from '../config';
import { toast } from 'react-toastify';
import { parseError, sortRussianThenEnglishByKey } from '../helpers';

export const A = {
  REQUEST_GET_ADMIN_DELIVERY_INFO: 'REQUEST_GET_ADMIN_DELIVERY_INFO',
  RECEIVE_GET_ADMIN_DELIVERY_INFO: 'RECEIVE_GET_ADMIN_DELIVERY_INFO',
  ERROR_GET_ADMIN_DELIVERY_INFO: 'ERROR_GET_ADMIN_DELIVERY_INFO',

  REQUEST_UPDATE_ADMIN_DELIVERY_INFO: 'REQUEST_UPDATE_ADMIN_DELIVERY_INFO',
  RECEIVE_UPDATE_ADMIN_DELIVERY_INFO: 'RECEIVE_UPDATE_ADMIN_DELIVERY_INFO',
  ERROR_UPDATE_ADMIN_DELIVERY_INFO: 'ERROR_UPDATE_ADMIN_DELIVERY_INFO',

  REQUEST_GET_ADMIN_PAYMENT_METHOD: 'REQUEST_GET_ADMIN_PAYMENT_METHOD',
  RECEIVE_GET_ADMIN_PAYMENT_METHOD: 'RECEIVE_GET_ADMIN_PAYMENT_METHOD',
  ERROR_GET_ADMIN_PAYMENT_METHOD: 'ERROR_GET_ADMIN_PAYMENT_METHOD',

  REQUEST_UPDATE_ADMIN_PAYMENT_METHOD: 'REQUEST_UPDATE_ADMIN_PAYMENT_METHOD',
  RECEIVE_UPDATE_ADMIN_PAYMENT_METHOD: 'RECEIVE_UPDATE_ADMIN_PAYMENT_METHOD',
  ERROR_UPDATE_ADMIN_PAYMENT_METHOD: 'ERROR_UPDATE_ADMIN_PAYMENT_METHOD',

  REQUEST_GET_ADMIN_CHECKOUT: 'REQUEST_GET_ADMIN_CHECKOUT',
  RECEIVE_GET_ADMIN_CHECKOUT: 'RECEIVE_GET_ADMIN_CHECKOUT',
  ERROR_GET_ADMIN_CHECKOUT: 'ERROR_GET_ADMIN_CHECKOUT',

  REQUEST_UPDATE_ADMIN_CHECKOUT: 'REQUEST_UPDATE_ADMIN_CHECKOUT',
  RECEIVE_UPDATE_ADMIN_CHECKOUT: 'RECEIVE_UPDATE_ADMIN_CHECKOUT',
  ERROR_UPDATE_ADMIN_CHECKOUT: 'ERROR_UPDATE_ADMIN_CHECKOUT',

  REQUEST_GET_ADMIN_SETTINGS: 'REQUEST_GET_ADMIN_SETTINGS',
  RECEIVE_GET_ADMIN_SETTINGS: 'RECEIVE_GET_ADMIN_SETTINGS',
  ERROR_GET_ADMIN_SETTINGS: 'ERROR_GET_ADMIN_SETTINGS',

  REQUEST_UPDATE_ADMIN_SETTINGS: 'REQUEST_UPDATE_ADMIN_SETTINGS',
  RECEIVE_UPDATE_ADMIN_SETTINGS: 'RECEIVE_UPDATE_ADMIN_SETTINGS',
  ERROR_UPDATE_ADMIN_SETTINGS: 'ERROR_UPDATE_ADMIN_SETTINGS',

  REQUEST_GET_ADMIN_WAREHOUSE: 'REQUEST_GET_ADMIN_WAREHOUSE',
  RECEIVE_GET_ADMIN_WAREHOUSE: 'RECEIVE_GET_ADMIN_WAREHOUSE',
  ERROR_GET_ADMIN_WAREHOUSE: 'ERROR_GET_ADMIN_WAREHOUSE',

  REQUEST_UPDATE_ADMIN_WAREHOUSE: 'REQUEST_UPDATE_ADMIN_WAREHOUSE',
  RECEIVE_UPDATE_ADMIN_WAREHOUSE: 'RECEIVE_UPDATE_ADMIN_WAREHOUSE',
  ERROR_UPDATE_ADMIN_WAREHOUSE: 'ERROR_UPDATE_ADMIN_WAREHOUSE',

  REQUEST_GET_ADMIN_STOCK: 'REQUEST_GET_ADMIN_STOCK',
  RECEIVE_GET_ADMIN_STOCK: 'RECEIVE_GET_ADMIN_STOCK',
  ERROR_GET_ADMIN_STOCK: 'ERROR_GET_ADMIN_STOCK',

  REQUEST_UPDATE_ORDER_TYPE: 'REQUEST_UPDATE_ORDER_TYPE',
  RECEIVE_UPDATE_ORDER_TYPE: 'RECEIVE_UPDATE_ORDER_TYPE',
  ERROR_UPDATE_ORDER_TYPE: 'ERROR_UPDATE_ORDER_TYPE',

  REQUEST_UPDATE_STOCK: 'REQUEST_UPDATE_STOCK',
  RECEIVE_UPDATE_STOCK: 'RECEIVE_UPDATE_STOCK',
  ERROR_UPDATE_STOCK: 'ERROR_UPDATE_STOCK',

  REQUEST_GET_ADMIN_COMPANIES: 'REQUEST_GET_ADMIN_COMPANIES',
  RECEIVE_GET_ADMIN_COMPANIES: 'RECEIVE_GET_ADMIN_COMPANIES',
  ERROR_GET_ADMIN_COMPANIES: 'ERROR_GET_ADMIN_COMPANIES',

  REQUEST_GET_ADMIN_HIERARCHY: 'REQUEST_GET_ADMIN_HIERARCHY',
  RECEIVE_GET_ADMIN_HIERARCHY: 'RECEIVE_GET_ADMIN_HIERARCHY',
  ERROR_GET_ADMIN_HIERARCHY: 'ERROR_GET_ADMIN_HIERARCHY',

  REQUEST_GET_ADMIN_PROVIDERS: 'REQUEST_GET_ADMIN_PROVIDERS',
  RECEIVE_GET_ADMIN_PROVIDERS: 'RECEIVE_GET_ADMIN_PROVIDERS',
  ERROR_GET_ADMIN_PROVIDERS: 'ERROR_GET_ADMIN_PROVIDERS',

  REQUEST_UPDATE_PROVIDER_STATUS: 'REQUEST_UPDATE_PROVIDER_STATUS',
  RECEIVE_UPDATE_PROVIDER_STATUS: 'RECEIVE_UPDATE_PROVIDER_STATUS',
  ERROR_UPDATE_PROVIDER_STATUS: 'ERROR_UPDATE_PROVIDER_STATUS',

  REQUEST_ORDER_ROLLBACK_TO_EDIT: 'REQUEST_ORDER_ROLLBACK_TO_EDIT',
  RECEIVE_ORDER_ROLLBACK_TO_EDIT: 'RECEIVE_ORDER_ROLLBACK_TO_EDIT',
  ERROR_ORDER_ROLLBACK_TO_EDIT: 'ERROR_ORDER_ROLLBACK_TO_EDIT',

  REQUEST_GET_MP_DTO_ORDERS: 'REQUEST_GET_MP_DTO_ORDERS',
  RECEIVE_GET_MP_DTO_ORDERS: 'RECEIVE_GET_MP_DTO_ORDERS',
  ERROR_GET_MP_DTO_ORDERS: 'ERROR_GET_MP_DTO_ORDERS',

  REQUEST_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS:
    'REQUEST_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS',
  RECEIVE_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS:
    'RECEIVE_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS',
  ERROR_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS: 'ERROR_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS',

  REQUEST_UPDATE_MP_DTO_ORDERS: 'REQUEST_UPDATE_MP_DTO_ORDERS',
  RECEIVE_UPDATE_MP_DTO_ORDERS: 'RECEIVE_UPDATE_MP_DTO_ORDERS',
  ERROR_UPDATE_MP_DTO_ORDERS: 'ERROR_UPDATE_MP_DTO_ORDERS',

  REQUEST_SUBMIT_STOCK_CORRECTION: 'REQUEST_SUBMIT_STOCK_CORRECTION',
  RECEIVE_SUBMIT_STOCK_CORRECTION: 'RECEIVE_SUBMIT_STOCK_CORRECTION',
  ERROR_SUBMIT_STOCK_CORRECTION: 'ERROR_SUBMIT_STOCK_CORRECTION',

  REQUEST_GET_SKU_QTY_CORRECTION: 'REQUEST_GET_SKU_QTY_CORRECTION',
  RECEIVE_GET_SKU_QTY_CORRECTION: 'RECEIVE_GET_SKU_QTY_CORRECTION',
  ERROR_GET_SKU_QTY_CORRECTION: 'ERROR_GET_SKU_QTY_CORRECTION',

  REQUEST_POST_SKU_QTY_CORRECTION: 'REQUEST_POST_SKU_QTY_CORRECTION',
  RECEIVE_POST_SKU_QTY_CORRECTION: 'RECEIVE_POST_SKU_QTY_CORRECTION',
  ERROR_POST_SKU_QTY_CORRECTION: 'ERROR_POST_SKU_QTY_CORRECTION',

  REQUEST_DELETE_SKU_QTY_CORRECTION: 'REQUEST_DELETE_SKU_QTY_CORRECTION',
  RECEIVE_DELETE_SKU_QTY_CORRECTION: 'RECEIVE_DELETE_SKU_QTY_CORRECTION',
  ERROR_DELETE_SKU_QTY_CORRECTION: 'ERROR_DELETE_SKU_QTY_CORRECTION',

  REQUEST_EDIT_DELIVERY_INFO_ITEM: 'REQUEST_EDIT_DELIVERY_INFO_ITEM',
  RECEIVE_EDIT_DELIVERY_INFO_ITEM: 'RECEIVE_EDIT_DELIVERY_INFO_ITEM',
  ERROR_EDIT_DELIVERY_INFO_ITEM: 'ERROR_EDIT_DELIVERY_INFO_ITEM',

  REQUEST_DELETE_DELIVERY_INFO_ITEM: 'REQUEST_DELETE_DELIVERY_INFO_ITEM',
  RECEIVE_DELETE_DELIVERY_INFO_ITEM: 'RECEIVE_DELETE_DELIVERY_INFO_ITEM',
  ERROR_DELETE_DELIVERY_INFO_ITEM: 'ERROR_DELETE_DELIVERY_INFO_ITEM',

  REQUEST_GET_DELIVERY_SERVICE_LIST: 'REQUEST_GET_DELIVERY_SERVICE_LIST',
  RECEIVE_GET_DELIVERY_SERVICE_LIST: 'RECEIVE_GET_DELIVERY_SERVICE_LIST',
  ERROR_GET_DELIVERY_SERVICE_LIST: 'ERROR_GET_DELIVERY_SERVICE_LIST',

  REQUEST_POST_ORDER_YAMARKET_TEST: 'REQUEST_POST_ORDER_YAMARKET_TEST',
  RECEIVE_POST_ORDER_YAMARKET_TEST: 'RECEIVE_POST_ORDER_YAMARKET_TEST',
  ERROR_POST_ORDER_YAMARKET_TEST: 'ERROR_POST_ORDER_YAMARKET_TEST',

  REQUEST_POST_ORDER_RESERVE_REPAIR: 'REQUEST_POST_ORDER_RESERVE_REPAIR',
  RECEIVE_POST_ORDER_RESERVE_REPAIR: 'RECEIVE_POST_ORDER_RESERVE_REPAIR',
  ERROR_POST_ORDER_RESERVE_REPAIR: 'ERROR_POST_ORDER_RESERVE_REPAIR',

  REQUEST_POST_ORDER_UPDATE_STATUS_FROM_WMS: 'REQUEST_POST_ORDER_UPDATE_STATUS_FROM_WMS',
  RECEIVE_POST_ORDER_UPDATE_STATUS_FROM_WMS: 'RECEIVE_POST_ORDER_UPDATE_STATUS_FROM_WMS',
  ERROR_POST_ORDER_UPDATE_STATUS_FROM_WMS: 'ERROR_POST_ORDER_UPDATE_STATUS_FROM_WMS',

  REQUEST_GET_FULFILLMENT_TYPES: 'REQUEST_GET_FULFILLMENT_TYPES',
  RECEIVE_GET_FULFILLMENT_TYPES: 'RECEIVE_GET_FULFILLMENT_TYPES',
  ERROR_GET_FULFILLMENT_TYPES: 'ERROR_GET_FULFILLMENT_TYPES',

  REQUEST_POST_WAREHOUSE: 'REQUEST_POST_WAREHOUSE',
  RECEIVE_POST_WAREHOUSE: 'RECEIVE_POST_WAREHOUSE',
  ERROR_POST_WAREHOUSE: 'ERROR_POST_WAREHOUSE',

  REQUEST_DELETE_WAREHOUSE: 'REQUEST_DELETE_WAREHOUSE',
  RECEIVE_DELETE_WAREHOUSE: 'RECEIVE_DELETE_WAREHOUSE',
  ERROR_DELETE_WAREHOUSE: 'ERROR_DELETE_WAREHOUSE',

  REQUEST_POST_ORDER_CHANGE_STATUS: 'REQUEST_POST_ORDER_CHANGE_STATUS',
  RECEIVE_POST_ORDER_CHANGE_STATUS: 'RECEIVE_POST_ORDER_CHANGE_STATUS',
  ERROR_POST_ORDER_CHANGE_STATUS: 'ERROR_POST_ORDER_CHANGE_STATUS',

  REQUEST_POST_CHECK_CONNECTION: 'REQUEST_POST_CHECK_CONNECTION',
  RECEIVE_POST_CHECK_CONNECTION: 'RECEIVE_POST_CHECK_CONNECTION',
  ERROR_POST_CHECK_CONNECTION: 'ERROR_POST_CHECK_CONNECTION',

  REQUEST_GET_ESHOP_INFO_LIST: 'REQUEST_GET_ESHOP_INFO_LIST',
  RECEIVE_GET_ESHOP_INFO_LIST: 'RECEIVE_GET_ESHOP_INFO_LIST',
  ERROR_GET_ESHOP_INFO_LIST: 'ERROR_GET_ESHOP_INFO_LIST',

  REQUEST_POST_ESHOP_INFO_LIST: 'REQUEST_POST_ESHOP_INFO_LIST',
  RECEIVE_POST_ESHOP_INFO_LIST: 'RECEIVE_POST_ESHOP_INFO_LIST',
  ERROR_POST_ESHOP_INFO_LIST: 'ERROR_POST_ESHOP_INFO_LIST',

  REQUEST_DELETE_ESHOP_INFO_ITEM: 'REQUEST_DELETE_ESHOP_INFO_ITEM',
  RECEIVE_DELETE_ESHOP_INFO_ITEM: 'RECEIVE_DELETE_ESHOP_INFO_ITEM',
  ERROR_DELETE_ESHOP_INFO_ITEM: 'ERROR_DELETE_ESHOP_INFO_ITEM',

  REQUEST_GET_ESHOP_TYPES: 'REQUEST_GET_ESHOP_TYPES',
  RECEIVE_GET_ESHOP_TYPES: 'RECEIVE_GET_ESHOP_TYPES',
  ERROR_GET_ESHOP_TYPES: 'ERROR_GET_ESHOP_TYPES',

  REQUEST_GET_ESHOP_TOKEN_ALIEXPRESS: 'REQUEST_GET_ESHOP_TOKEN_ALIEXPRESS',
  RECEIVE_GET_ESHOP_TOKEN_ALIEXPRESS: 'RECEIVE_GET_ESHOP_TOKEN_ALIEXPRESS',
  ERROR_GET_ESHOP_TOKEN_ALIEXPRESS: 'ERROR_GET_ESHOP_TOKEN_ALIEXPRESS',

  REQUEST_GET_ESHOP_PRICE_TYPE: 'REQUEST_GET_ESHOP_PRICE_TYPE',
  RECEIVE_GET_ESHOP_PRICE_TYPE: 'RECEIVE_GET_ESHOP_PRICE_TYPE',
  ERROR_GET_ESHOP_PRICE_TYPE: 'ERROR_GET_ESHOP_PRICE_TYPE',

  REQUEST_POST_ESHOP_TEST_CONNECTION: 'REQUEST_POST_ESHOP_TEST_CONNECTION',
  RECEIVE_POST_ESHOP_TEST_CONNECTION: 'RECEIVE_POST_ESHOP_TEST_CONNECTION',
  ERROR_POST_ESHOP_TEST_CONNECTION: 'ERROR_POST_ESHOP_TEST_CONNECTION',

  REQUEST_POST_ESHOP_EXPORT_ALL_NOMENCLATURE: 'REQUEST_POST_ESHOP_EXPORT_ALL_NOMENCLATURE',
  RECEIVE_POST_ESHOP_EXPORT_ALL_NOMENCLATURE: 'RECEIVE_POST_ESHOP_EXPORT_ALL_NOMENCLATURE',
  ERROR_POST_ESHOP_EXPORT_ALL_NOMENCLATURE: 'ERROR_POST_ESHOP_EXPORT_ALL_NOMENCLATURE',

  REQUEST_GET_ESHOP_OZON_WAREHOUSE_LIST: 'REQUEST_GET_ESHOP_OZON_WAREHOUSE_LIST',
  RECEIVE_GET_ESHOP_OZON_WAREHOUSE_LIST: 'RECEIVE_GET_ESHOP_OZON_WAREHOUSE_LIST',
  ERROR_GET_ESHOP_OZON_WAREHOUSE_LIST: 'ERROR_GET_ESHOP_OZON_WAREHOUSE_LIST',

  REQUEST_GET_ADMIN_SUBTYPES_FBO: 'REQUEST_GET_ADMIN_SUBTYPES_FBO',
  RECEIVE_GET_ADMIN_SUBTYPES_FBO: 'RECEIVE_GET_ADMIN_SUBTYPES_FBO',
  ERROR_GET_ADMIN_SUBTYPES_FBO: 'ERROR_GET_ADMIN_SUBTYPES_FBO',

  REQUEST_POST_ADMIN_SUBTYPES_FBO: 'REQUEST_POST_ADMIN_SUBTYPES_FBO',
  RECEIVE_POST_ADMIN_SUBTYPES_FBO: 'RECEIVE_POST_ADMIN_SUBTYPES_FBO',
  ERROR_POST_ADMIN_SUBTYPES_FBO: 'ERROR_POST_ADMIN_SUBTYPES_FBO',

  REQUEST_DELETE_ADMIN_SUBTYPES_FBO: 'REQUEST_DELETE_ADMIN_SUBTYPES_FBO',
  RECEIVE_DELETE_ADMIN_SUBTYPES_FBO: 'RECEIVE_DELETE_ADMIN_SUBTYPES_FBO',
  ERROR_DELETE_ADMIN_SUBTYPES_FBO: 'ERROR_DELETE_ADMIN_SUBTYPES_FBO',
};

/*
 * Информация о доставке
 */

const requestGetAdminDeliveryInfo = () => {
  return {
    type: A.REQUEST_GET_ADMIN_DELIVERY_INFO,
  };
};

const receiveGetAdminDeliveryInfo = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_DELIVERY_INFO,
    data,
  };
};

const errorGetAdminDeliveryInfo = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_DELIVERY_INFO,
    err,
  };
};

export const fetchGetAdminDeliveryInfo = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminDeliveryInfo());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/delivery-info-list',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminDeliveryInfo(res));
        } else {
          dispatch(errorGetAdminDeliveryInfo('Ошибка получения информации о доставке'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminDeliveryInfo(err));
      },
    });
  };
};

const requestUpdateAdminDeliveryInfo = () => {
  return {
    type: A.REQUEST_UPDATE_ADMIN_DELIVERY_INFO,
  };
};

const receiveUpdateAdminDeliveryInfo = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ADMIN_DELIVERY_INFO,
    data,
  };
};

const errorUpdateAdminDeliveryInfo = (err) => {
  return {
    type: A.ERROR_UPDATE_ADMIN_DELIVERY_INFO,
    err,
  };
};

export const fetchUpdateAdminDeliveryInfo = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminDeliveryInfo());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/delivery-info-list`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminDeliveryInfo());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdminDeliveryInfo(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminDeliveryInfo(err));
          reject(err);
        },
      });
    });
  };
};

/*
 * Информация о способе оплаты
 */

const requestGetAdminPaymentMethod = () => {
  return {
    type: A.REQUEST_GET_ADMIN_PAYMENT_METHOD,
  };
};

const receiveGetAdminPaymentMethod = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_PAYMENT_METHOD,
    data,
  };
};

const errorGetAdminPaymentMethod = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_PAYMENT_METHOD,
    err,
  };
};

export const fetchGetAdminPaymentMethod = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminPaymentMethod());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/payment-method',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminPaymentMethod(res));
        } else {
          dispatch(errorGetAdminPaymentMethod('Ошибка получения информации о доставке'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminPaymentMethod(err));
      },
    });
  };
};

const requestUpdateAdminPaymentMethod = () => {
  return {
    type: A.REQUEST_UPDATE_ADMIN_PAYMENT_METHOD,
  };
};

const receiveUpdateAdminPaymentMethod = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ADMIN_PAYMENT_METHOD,
    data,
  };
};

const errorUpdateAdminPaymentMethod = (err) => {
  return {
    type: A.ERROR_UPDATE_ADMIN_PAYMENT_METHOD,
    err,
  };
};

export const fetchUpdateAdminPaymentMethod = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminPaymentMethod());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/payment-method`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminPaymentMethod());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdminPaymentMethod(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminPaymentMethod(err));
          reject(err);
        },
      });
    });
  };
};

/*
 * Настройки чекаута
 */

const requestGetAdminCheckout = () => {
  return {
    type: A.REQUEST_GET_ADMIN_CHECKOUT,
  };
};

const receiveGetAdminCheckout = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_CHECKOUT,
    data,
  };
};

const errorGetAdminCheckout = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_CHECKOUT,
    err,
  };
};

export const fetchGetAdminCheckout = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminCheckout());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/checkout',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminCheckout(res));
        } else {
          dispatch(errorGetAdminCheckout('Ошибка получения информации о чекауте'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminCheckout(err));
      },
    });
  };
};

const requestUpdateAdminCheckout = () => {
  return {
    type: A.REQUEST_UPDATE_ADMIN_CHECKOUT,
  };
};

const receiveUpdateAdminCheckout = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ADMIN_CHECKOUT,
    data,
  };
};

const errorUpdateAdminCheckout = (err) => {
  return {
    type: A.ERROR_UPDATE_ADMIN_CHECKOUT,
    err,
  };
};

export const fetchUpdateAdminCheckout = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminCheckout());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/checkout`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminCheckout());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(receiveUpdateAdminCheckout(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminCheckout(err));
          reject(err);
        },
      });
    });
  };
};

/*
 * Настройки lite
 */

const requestGetAdminSettings = () => {
  return {
    type: A.REQUEST_GET_ADMIN_SETTINGS,
  };
};

const receiveGetAdminSettings = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_SETTINGS,
    data,
  };
};

const errorGetAdminSettings = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_SETTINGS,
    err,
  };
};

export const fetchGetAdminSettings = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminSettings());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/lite',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminSettings(res));
        } else {
          dispatch(errorGetAdminSettings('Ошибка получения настроек'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminSettings(err));
      },
    });
  };
};

const requestUpdateAdminSettings = () => {
  return {
    type: A.REQUEST_UPDATE_ADMIN_SETTINGS,
  };
};

const receiveUpdateAdminSettings = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ADMIN_SETTINGS,
    data,
  };
};

const errorUpdateAdminSettings = (err) => {
  return {
    type: A.ERROR_UPDATE_ADMIN_SETTINGS,
    err,
  };
};

export const fetchUpdateAdminSettings = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminSettings());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/lite`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminSettings());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdminSettings(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminSettings(err));
          reject(err);
        },
      });
    });
  };
};

/*
 * Настройки склада
 */

const requestGetAdminWarehouse = () => {
  return {
    type: A.REQUEST_GET_ADMIN_WAREHOUSE,
  };
};

const receiveGetAdminWarehouse = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_WAREHOUSE,
    data,
  };
};

const errorGetAdminWarehouse = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_WAREHOUSE,
    err,
  };
};

export const fetchGetAdminWarehouse = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminWarehouse());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/warehouse-info-list',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminWarehouse(res));
        } else {
          dispatch(errorGetAdminWarehouse('Ошибка получения склада'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminWarehouse(err));
      },
    });
  };
};

const requestUpdateAdminWarehouse = () => {
  return {
    type: A.REQUEST_UPDATE_ADMIN_WAREHOUSE,
  };
};

const receiveUpdateAdminWarehouse = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ADMIN_WAREHOUSE,
    data,
  };
};

const errorUpdateAdminWarehouse = (err) => {
  return {
    type: A.ERROR_UPDATE_ADMIN_WAREHOUSE,
    err,
  };
};

export const fetchUpdateAdminWarehouse = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminWarehouse());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/warehouses`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminWarehouse());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdminWarehouse(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminWarehouse(err));
          reject(err);
        },
      });
    });
  };
};

/*Установка типа заказа*/

const requestUpdateOrderType = () => {
  return {
    type: A.REQUEST_UPDATE_ORDER_TYPE,
  };
};

const receiveUpdateOrderType = (data) => {
  return {
    type: A.RECEIVE_UPDATE_ORDER_TYPE,
    data,
  };
};

const errorUpdateOrderType = (err) => {
  return {
    type: A.ERROR_UPDATE_ORDER_TYPE,
    err,
  };
};

export const fetchUpdateOrderType = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderType());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/type`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderType());
            resolve(res);
            toast.info('Тип заказа успешно установлен');
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderType(err));
            reject(err);
            toast.error(parseError(err));
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderType(err));
          reject(err);
        },
      });
    });
  };
};

/*Коррекция остатков*/
const requestUpdateStock = () => {
  return {
    type: A.REQUEST_UPDATE_STOCK,
  };
};

const receiveUpdateStock = (data) => {
  return {
    type: A.RECEIVE_UPDATE_STOCK,
    data,
  };
};

const errorUpdateStock = (err) => {
  return {
    type: A.ERROR_UPDATE_STOCK,
    err,
  };
};

export const fetchUpdateStock = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateStock());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/stock-correction`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateStock());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateStock(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateStock(err));
          reject(err);
        },
      });
    });
  };
};

/*Список компаний доставщиков*/

const requestGetAdminCompanies = () => {
  return {
    type: A.REQUEST_GET_ADMIN_COMPANIES,
  };
};

const receiveGetAdminCompanies = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_COMPANIES,
    data,
  };
};

const errorGetAdminCompanies = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_COMPANIES,
    err,
  };
};

export const fetchGetAdminCompanies = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminCompanies());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/delivery-info/companies',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        dispatch(receiveGetAdminCompanies(res));
      },
      error: (err) => {
        dispatch(errorGetAdminCompanies(err));
      },
    });
  };
};

/* Получение информации для плашки Иерархия документов */

export const fetchGetHierarchy = (orderId) => {
  let url = `${HOST}/api/lite/admin/order/hierarchy?id=${orderId}`;
  return (dispatch, getState) => {
    dispatch(requestGetAdminHierarchy());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetAdminHierarchy());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAdminHierarchy(err));
            reject(err);
            toast.error('Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorGetAdminHierarchy(err));
          reject(err);
          toast.error('Возникла ошибка, обратитесь в поддержку');
        },
      });
    });
  };
};

const requestGetAdminHierarchy = () => {
  return {
    type: A.REQUEST_GET_ADMIN_HIERARCHY,
  };
};

const receiveGetAdminHierarchy = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_HIERARCHY,
    data,
  };
};

const errorGetAdminHierarchy = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_HIERARCHY,
    err,
  };
};

/* Получение списка провайдеров услуг в админ-панели*/

export const fetchGetAdminProviders = () => {
  let url = `${HOST}/api/lite/admin/service/providers/setup/claim`;
  return (dispatch, getState) => {
    dispatch(requestGetAdminProviders());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetAdminProviders(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetAdminProviders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetAdminProviders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetAdminProviders = () => {
  return {
    type: A.REQUEST_GET_ADMIN_PROVIDERS,
  };
};

const receiveGetAdminProviders = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_PROVIDERS,
    data,
  };
};

const errorGetAdminProviders = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_PROVIDERS,
    err,
  };
};

/*Редакция поля status в заявках на подключение*/

export const fetchUpdateProviderStatus = (data) => {
  const { status, id } = data;

  return (dispatch, getState) => {
    dispatch(requestUpdateProviderStatus());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/service/providers/claim/status?id=${id}`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateProviderStatus());
            resolve(res);
            toast.info('Статус успешно обновлен');
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateProviderStatus(err));
            reject(err);
            toast.error('Возникла ошибка, обратитесь в поддержку');
          }
        },
        error: (err) => {
          dispatch(errorUpdateProviderStatus(err));
          reject(err);
          toast.error('Возникла ошибка, обратитесь в поддержку');
        },
      });
    });
  };
};

const requestUpdateProviderStatus = () => {
  return {
    type: A.REQUEST_UPDATE_PROVIDER_STATUS,
  };
};

const receiveUpdateProviderStatus = (data) => {
  return {
    type: A.RECEIVE_UPDATE_PROVIDER_STATUS,
    data,
  };
};

const errorUpdateProviderStatus = (err) => {
  return {
    type: A.ERROR_UPDATE_PROVIDER_STATUS,
    err,
  };
};

export const fetchOrderRollbackToEdit = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateOrderType());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/rollback/to/edit`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateOrderType());
            resolve(res);
            toast.info('Тип заказа успешно установлен');
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateOrderType(err));
            reject(err);
            toast.error(parseError(err));
          }
        },
        error: (err) => {
          dispatch(errorUpdateOrderType(err));
          reject(err);
        },
      });
    });
  };
};

const requestOrderRollbackToEdit = () => {
  return {
    type: A.REQUEST_ORDER_ROLLBACK_TO_EDIT,
  };
};

const receiveOrderRollbackToEdit = (data) => {
  return {
    type: A.RECEIVE_ORDER_ROLLBACK_TO_EDIT,
    data,
  };
};

const errorOrderRollbackToEdit = (err) => {
  return {
    type: A.ERROR_ORDER_ROLLBACK_TO_EDIT,
    err,
  };
};

/* Получение списка MP DTO заказов в админ-панели*/

export const fetchGetMpDtoOrders = (data) => {
  const { page = 1, size = 15, search } = data;

  let url = `${HOST}/api/lite/admin/dto/orders/mp?size=${size}`;

  if (search) url += `&id=${search}`;
  if (page) url += `&page=${page}`;

  return (dispatch, getState) => {
    dispatch(requestGetMpDtoOrders());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetMpDtoOrders(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetMpDtoOrders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetMpDtoOrders(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetMpDtoOrders = () => {
  return {
    type: A.REQUEST_GET_MP_DTO_ORDERS,
  };
};

const receiveGetMpDtoOrders = (data) => {
  return {
    type: A.RECEIVE_GET_MP_DTO_ORDERS,
    data,
  };
};

const errorGetMpDtoOrders = (err) => {
  return {
    type: A.ERROR_GET_MP_DTO_ORDERS,
    err,
  };
};

export const fetchOrderRollbackBeforeLoadingDocuments = (data) => {
  return (dispatch, getState) => {
    dispatch(requestOrderRollbackBeforeLoadingDocuments());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/fbo/status`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveOrderRollbackBeforeLoadingDocuments());
            resolve(res);
            toast.info(res);
          }
        },
        error: (err) => {
          dispatch(errorOrderRollbackBeforeLoadingDocuments(err));
          reject(err);
        },
      });
    });
  };
};

const requestOrderRollbackBeforeLoadingDocuments = () => {
  return {
    type: A.REQUEST_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS,
  };
};

const receiveOrderRollbackBeforeLoadingDocuments = (data) => {
  return {
    type: A.RECEIVE_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS,
    data,
  };
};

const errorOrderRollbackBeforeLoadingDocuments = (err) => {
  return {
    type: A.ERROR_ORDER_ROLLBACK_BEFORE_LOADING_DOCUMENTS,
    err,
  };
};

const requestUpdateAdminMpDtoOrders = () => {
  return {
    type: A.REQUEST_UPDATE_MP_DTO_ORDERS,
  };
};

const receiveUpdateAdminMpDtoOrders = (data) => {
  return {
    type: A.RECEIVE_UPDATE_MP_DTO_ORDERS,
    data,
  };
};

const errorUpdateAdminMpDtoOrders = (err) => {
  return {
    type: A.ERROR_UPDATE_MP_DTO_ORDERS,
    err,
  };
};

export const fetchUpdateMpDtoOrders = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateAdminMpDtoOrders());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/dto/orders/mp`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateAdminMpDtoOrders());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateAdminMpDtoOrders(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateAdminMpDtoOrders(err));
          reject(err);
        },
      });
    });
  };
};

const requestSubmitStockCorrection = () => {
  return {
    type: A.REQUEST_SUBMIT_STOCK_CORRECTION,
  };
};

const receiveSubmitStockCorrection = (data) => {
  return {
    type: A.RECEIVE_SUBMIT_STOCK_CORRECTION,
    data,
  };
};

const errorSubmitStockCorrection = (err) => {
  return {
    type: A.ERROR_SUBMIT_STOCK_CORRECTION,
    err,
  };
};

export const fetchSubmitStockCorrection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestSubmitStockCorrection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/stock-correction`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveSubmitStockCorrection());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorSubmitStockCorrection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorSubmitStockCorrection(err));
          reject(err);
        },
      });
    });
  };
};

export const fetchGetSkuQtyCorrection = (queryParams) => {
  return (dispatch, getState) => {
    dispatch(requestGetSkuQtyCorrection());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/sku-qty-correction?${queryParams}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetSkuQtyCorrection(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetSkuQtyCorrection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetSkuQtyCorrection(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSkuQtyCorrection = () => {
  return {
    type: A.REQUEST_GET_SKU_QTY_CORRECTION,
  };
};

const receiveGetSkuQtyCorrection = (data) => {
  return {
    type: A.RECEIVE_GET_SKU_QTY_CORRECTION,
    data,
  };
};

const errorGetSkuQtyCorrection = (err) => {
  return {
    type: A.ERROR_GET_SKU_QTY_CORRECTION,
    err,
  };
};

export const fetchPostSkuQtyCorrection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostSkuQtyCorrection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/sku-qty-correction`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostSkuQtyCorrection());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostSkuQtyCorrection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostSkuQtyCorrection(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostSkuQtyCorrection = () => {
  return {
    type: A.REQUEST_POST_SKU_QTY_CORRECTION,
  };
};

const receivePostSkuQtyCorrection = (data) => {
  return {
    type: A.RECEIVE_POST_SKU_QTY_CORRECTION,
    data,
  };
};

const errorPostSkuQtyCorrection = (err) => {
  return {
    type: A.ERROR_POST_SKU_QTY_CORRECTION,
    err,
  };
};

export const fetchDeleteSkuQtyCorrection = (humanId) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteSkuQtyCorrection());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/admin/sku-qty-correction?id=${humanId}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteSkuQtyCorrection());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteSkuQtyCorrection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteSkuQtyCorrection(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteSkuQtyCorrection = () => {
  return {
    type: A.REQUEST_DELETE_SKU_QTY_CORRECTION,
  };
};

const receiveDeleteSkuQtyCorrection = (data) => {
  return {
    type: A.RECEIVE_DELETE_SKU_QTY_CORRECTION,
    data,
  };
};

const errorDeleteSkuQtyCorrection = (err) => {
  return {
    type: A.ERROR_DELETE_SKU_QTY_CORRECTION,
    err,
  };
};

export const fetchDeleteDeliveryInfoItem = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteDeliveryInfoItem());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/admin/settings/delivery-info-list?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteDeliveryInfoItem());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteDeliveryInfoItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteDeliveryInfoItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteDeliveryInfoItem = () => {
  return {
    type: A.REQUEST_DELETE_DELIVERY_INFO_ITEM,
  };
};

const receiveDeleteDeliveryInfoItem = (data) => {
  return {
    type: A.RECEIVE_DELETE_DELIVERY_INFO_ITEM,
    data,
  };
};

const errorDeleteDeliveryInfoItem = (err) => {
  return {
    type: A.ERROR_DELETE_DELIVERY_INFO_ITEM,
    err,
  };
};

export const fetchGetDeliveryList = () => {
  return (dispatch, getState) => {
    dispatch(requestGetDeliveryList());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/settings/delivery-info-list/services-and-products`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetDeliveryList(res.deliveryCompanies));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetDeliveryList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetDeliveryList(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetDeliveryList = () => {
  return {
    type: A.REQUEST_GET_DELIVERY_SERVICE_LIST,
  };
};

const receiveGetDeliveryList = (data) => {
  return {
    type: A.RECEIVE_GET_DELIVERY_SERVICE_LIST,
    data,
  };
};

const errorGetDeliveryList = (err) => {
  return {
    type: A.ERROR_GET_DELIVERY_SERVICE_LIST,
    err,
  };
};

export const fetchCreateOrEditDeliveryItem = (data, type) => {
  return (dispatch, getState) => {
    dispatch(requestEditDeliveryInfoItem());
    return new Promise((resolve, reject) => {
      apiPost({
        url:
          data.code !== null
            ? `${HOST}/api/lite/admin/settings/delivery-info-list?id=${data.code}`
            : `${HOST}/api/lite/admin/settings/delivery-info-list`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveEditDeliveryInfoItem());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorEditDeliveryInfoItem(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorEditDeliveryInfoItem(err));
          reject(err);
        },
      });
    });
  };
};

const requestEditDeliveryInfoItem = () => {
  return {
    type: A.REQUEST_EDIT_DELIVERY_INFO_ITEM,
  };
};

const receiveEditDeliveryInfoItem = (data) => {
  return {
    type: A.RECEIVE_EDIT_DELIVERY_INFO_ITEM,
    data,
  };
};

const errorEditDeliveryInfoItem = (err) => {
  return {
    type: A.ERROR_EDIT_DELIVERY_INFO_ITEM,
    err,
  };
};

export const fetchPostOrderReserveRepair = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostOrderReserveRepair());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/reserve/repair`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostOrderReserveRepair());
            resolve(res);
            toast.info(`Товары убраны из заказа успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при удалении товаров из заказа');
            dispatch(errorPostOrderReserveRepair(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOrderReserveRepair(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOrderReserveRepair = () => {
  return {
    type: A.REQUEST_POST_ORDER_RESERVE_REPAIR,
  };
};

const receivePostOrderReserveRepair = (data) => {
  return {
    type: A.RECEIVE_POST_ORDER_RESERVE_REPAIR,
    data,
  };
};

const errorPostOrderReserveRepair = (err) => {
  return {
    type: A.ERROR_POST_ORDER_RESERVE_REPAIR,
    err,
  };
};

export const fetchPostOrderYamarketTest = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostOrderYamarketTest());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/yamarket/test`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostOrderYamarketTest());
            resolve(res);
            toast.info(`Тестовый сценарий выполнен успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при выполнении теста');
            dispatch(errorPostOrderYamarketTest(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOrderYamarketTest(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOrderYamarketTest = () => {
  return {
    type: A.REQUEST_POST_ORDER_YAMARKET_TEST,
  };
};

const receivePostOrderYamarketTest = (data) => {
  return {
    type: A.RECEIVE_POST_ORDER_YAMARKET_TEST,
    data,
  };
};

const errorPostOrderYamarketTest = (err) => {
  return {
    type: A.ERROR_POST_ORDER_YAMARKET_TEST,
    err,
  };
};

export const fetchPostOrderUpdateStatusFromWMS = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostOrderUpdateStatusFromWMS());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/get-shipments`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostOrderUpdateStatusFromWMS());
            resolve(res);
            toast.info(`Статус заказа актуализирован успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при актуализации статуса заказа');
            dispatch(errorPostOrderUpdateStatusFromWMS(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOrderUpdateStatusFromWMS(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOrderUpdateStatusFromWMS = () => {
  return {
    type: A.REQUEST_POST_ORDER_UPDATE_STATUS_FROM_WMS,
  };
};

const receivePostOrderUpdateStatusFromWMS = (data) => {
  return {
    type: A.RECEIVE_POST_ORDER_UPDATE_STATUS_FROM_WMS,
    data,
  };
};

const errorPostOrderUpdateStatusFromWMS = (err) => {
  return {
    type: A.ERROR_POST_ORDER_UPDATE_STATUS_FROM_WMS,
    err,
  };
};

/* Получение списка возможных значений fulfillmentType и их зависимых fulfillmentSubType и русской транскрипции*/

export const fetchGetFulFillmentTypes = () => {
  let url = `${HOST}/api/lite/admin/settings/warehouse-info-list/fulfillment_types`;
  return (dispatch, getState) => {
    dispatch(requestGetFulFillmentTypes());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetFulFillmentTypes(res.fulfillmentInfos));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetFulFillmentTypes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetFulFillmentTypes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetFulFillmentTypes = () => {
  return {
    type: A.REQUEST_GET_FULFILLMENT_TYPES,
  };
};

const receiveGetFulFillmentTypes = (data) => {
  return {
    type: A.RECEIVE_GET_FULFILLMENT_TYPES,
    data,
  };
};

const errorGetFulFillmentTypes = (err) => {
  return {
    type: A.ERROR_GET_FULFILLMENT_TYPES,
    err,
  };
};

export const fetchPostWarehouseCorrection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostWarehouse());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/warehouse-info-list?=${data.code}`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostWarehouse());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostWarehouse(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostWarehouse(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostWarehouse = () => {
  return {
    type: A.REQUEST_POST_WAREHOUSE,
  };
};

const receivePostWarehouse = (data) => {
  return {
    type: A.RECEIVE_POST_WAREHOUSE,
    data,
  };
};

const errorPostWarehouse = (err) => {
  return {
    type: A.ERROR_POST_WAREHOUSE,
    err,
  };
};

export const fetchDeleteWarehouse = (id) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteWarehouse());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/admin/settings/warehouse-info-list?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteWarehouse());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteWarehouse(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteWarehouse(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteWarehouse = () => {
  return {
    type: A.REQUEST_DELETE_WAREHOUSE,
  };
};

const receiveDeleteWarehouse = (data) => {
  return {
    type: A.RECEIVE_DELETE_WAREHOUSE,
    data,
  };
};

const errorDeleteWarehouse = (err) => {
  return {
    type: A.ERROR_DELETE_WAREHOUSE,
    err,
  };
};

export const fetchPostOrderChangeStatus = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostOrderChangeStatus());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/order/status`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostOrderChangeStatus());
            resolve(res);
            toast.info(`Статус заказа изменен успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при изменении статуса заказа');
            dispatch(errorPostOrderChangeStatus(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostOrderChangeStatus(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostOrderChangeStatus = () => {
  return {
    type: A.REQUEST_POST_ORDER_CHANGE_STATUS,
  };
};

const receivePostOrderChangeStatus = (data) => {
  return {
    type: A.RECEIVE_POST_ORDER_CHANGE_STATUS,
    data,
  };
};

const errorPostOrderChangeStatus = (err) => {
  return {
    type: A.ERROR_POST_ORDER_CHANGE_STATUS,
    err,
  };
};

export const fetchPostCheckConnection = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostCheckConnection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/warehouse-info-list/test-connection?id=${data}`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostCheckConnection());
            resolve(res);
            toast.info(`Соединение со складом работает`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка соединения со складом');
            dispatch(errorPostCheckConnection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostCheckConnection(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostCheckConnection = () => {
  return {
    type: A.REQUEST_POST_ORDER_CHANGE_STATUS,
  };
};

const receivePostCheckConnection = (data) => {
  return {
    type: A.RECEIVE_POST_ORDER_CHANGE_STATUS,
    data,
  };
};

const errorPostCheckConnection = (err) => {
  return {
    type: A.ERROR_POST_ORDER_CHANGE_STATUS,
    err,
  };
};

export const fetchGetEshopInfoList = (query) => {
  let url = `${HOST}/api/lite/admin/settings/eshop-info-list`;
  if (query) url += query;

  return (dispatch, getState) => {
    dispatch(requestGetEshopInfoList());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            if (!query && res?.eshopInfoDtoList) {
              const sorted = sortRussianThenEnglishByKey(res.eshopInfoDtoList, 'title');
              dispatch(receiveGetEshopInfoList(sorted));
            }
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEshopInfoList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEshopInfoList(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshopInfoList = () => {
  return {
    type: A.REQUEST_GET_ESHOP_INFO_LIST,
  };
};

export const receiveGetEshopInfoList = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOP_INFO_LIST,
    data,
  };
};

const errorGetEshopInfoList = (err) => {
  return {
    type: A.ERROR_GET_ESHOP_INFO_LIST,
    err,
  };
};

export const fetchPostEshopInfoList = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostEshopInfoList());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostEshopInfoList());
            resolve(res);
            toast.info(`Данные магазина успешно сохранены!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при сохранении данных магазина');
            dispatch(errorPostEshopInfoList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostEshopInfoList(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostEshopInfoList = () => {
  return {
    type: A.REQUEST_POST_ESHOP_INFO_LIST,
  };
};

const receivePostEshopInfoList = (data) => {
  return {
    type: A.RECEIVE_POST_ESHOP_INFO_LIST,
    data,
  };
};

const errorPostEshopInfoList = (err) => {
  return {
    type: A.ERROR_POST_ESHOP_INFO_LIST,
    err,
  };
};

export const fetchDeleteEshopInfoItem = (id) => {
  if (!id) return;
  return (dispatch, getState) => {
    dispatch(requestDeleteEshopInfoList());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteEshopInfoList());
            resolve(res);
            toast.info(`Магазин успешно удален!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при удалении магазина');
            dispatch(errorDeleteEshopInfoList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteEshopInfoList(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteEshopInfoList = () => {
  return {
    type: A.REQUEST_DELETE_ESHOP_INFO_ITEM,
  };
};

const receiveDeleteEshopInfoList = (data) => {
  return {
    type: A.RECEIVE_DELETE_ESHOP_INFO_ITEM,
    data,
  };
};

const errorDeleteEshopInfoList = (err) => {
  return {
    type: A.ERROR_DELETE_ESHOP_INFO_ITEM,
    err,
  };
};

export const fetchGetEshopTypes = () => {
  return (dispatch, getState) => {
    dispatch(requestGetEshopTypes());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/eshop-types`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetEshopTypes(res.eshopTypeList));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEshopTypes(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEshopTypes(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshopTypes = () => {
  return {
    type: A.REQUEST_GET_ESHOP_TYPES,
  };
};

const receiveGetEshopTypes = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOP_TYPES,
    data,
  };
};

const errorGetEshopTypes = (err) => {
  return {
    type: A.ERROR_GET_ESHOP_TYPES,
    err,
  };
};

export const fetchGetEshopTokenAliexpress = (id) => {
  return (dispatch, getState) => {
    dispatch(requestGetEshopTokenAliexpress());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/get-token-aliExpress?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetEshopTokenAliexpress(res.eshopTypeList));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEshopTokenAliexpress(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEshopTokenAliexpress(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshopTokenAliexpress = () => {
  return {
    type: A.REQUEST_GET_ESHOP_TOKEN_ALIEXPRESS,
  };
};

const receiveGetEshopTokenAliexpress = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOP_TOKEN_ALIEXPRESS,
    data,
  };
};

const errorGetEshopTokenAliexpress = (err) => {
  return {
    type: A.ERROR_GET_ESHOP_TOKEN_ALIEXPRESS,
    err,
  };
};

export const fetchGetEshopPriceType = (id) => {
  return (dispatch, getState) => {
    dispatch(requestGetEshopPriceType());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/price-type`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetEshopPriceType(res.priceTypes));
            resolve(res.priceTypes);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEshopPriceType(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEshopPriceType(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshopPriceType = () => {
  return {
    type: A.REQUEST_GET_ESHOP_PRICE_TYPE,
  };
};

const receiveGetEshopPriceType = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOP_PRICE_TYPE,
    data,
  };
};

const errorGetEshopPriceType = (err) => {
  return {
    type: A.ERROR_GET_ESHOP_PRICE_TYPE,
    err,
  };
};

export const fetchPostEshopTestConnection = (id) => {
  return (dispatch, getState) => {
    dispatch(requestPostEshopTestConnection());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/test-connection?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostEshopTestConnection());
            resolve(res);
            toast.info(`Тест соединения прошел успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при тестировании соединения');
            dispatch(errorPostEshopTestConnection(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostEshopTestConnection(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostEshopTestConnection = () => {
  return {
    type: A.REQUEST_POST_ESHOP_TEST_CONNECTION,
  };
};

const receivePostEshopTestConnection = (data) => {
  return {
    type: A.RECEIVE_POST_ESHOP_TEST_CONNECTION,
    data,
  };
};

const errorPostEshopTestConnection = (err) => {
  return {
    type: A.ERROR_POST_ESHOP_TEST_CONNECTION,
    err,
  };
};

export const fetchPostEshopExportAllNomenclature = (id) => {
  return (dispatch, getState) => {
    dispatch(requestPostEshopExportAllNomenclature());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/export-items?id=${id}`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostEshopExportAllNomenclature());
            resolve(res);
            toast.info(`Экспорт номенклатуры прошел успешно!`);
          } else {
            const err = { data: { errors: res.errors } };
            toast.error(err.data.errors?.[0]?.message || 'Ошибка при экспорте номенклатуры');
            dispatch(errorPostEshopExportAllNomenclature(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostEshopExportAllNomenclature(err));
          reject(err);
        },
      });
    });
  };
};

const requestPostEshopExportAllNomenclature = () => {
  return {
    type: A.REQUEST_POST_ESHOP_EXPORT_ALL_NOMENCLATURE,
  };
};

const receivePostEshopExportAllNomenclature = (data) => {
  return {
    type: A.RECEIVE_POST_ESHOP_EXPORT_ALL_NOMENCLATURE,
    data,
  };
};

const errorPostEshopExportAllNomenclature = (err) => {
  return {
    type: A.ERROR_POST_ESHOP_EXPORT_ALL_NOMENCLATURE,
    err,
  };
};

export const fetchGetEshopOzonWarehouseList = () => {
  return (dispatch, getState) => {
    dispatch(requestGetEshopOzonWarehouseList());
    return new Promise((resolve, reject) => {
      apiGet({
        url: `${HOST}/api/lite/admin/settings/eshop-info-list/ozon-warehouse-list`,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetEshopOzonWarehouseList(res.warehouse));
            resolve(res.warehouse);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetEshopOzonWarehouseList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetEshopOzonWarehouseList(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetEshopOzonWarehouseList = () => {
  return {
    type: A.REQUEST_GET_ESHOP_OZON_WAREHOUSE_LIST,
  };
};

const receiveGetEshopOzonWarehouseList = (data) => {
  return {
    type: A.RECEIVE_GET_ESHOP_OZON_WAREHOUSE_LIST,
    data,
  };
};

const errorGetEshopOzonWarehouseList = (err) => {
  return {
    type: A.ERROR_GET_ESHOP_OZON_WAREHOUSE_LIST,
    err,
  };
};

export const fetchGetAdminSubtypesFbo = () => {
  return (dispatch, getState) => {
    dispatch(requestGetAdminSubtypesFbo());
    return apiGet({
      url: HOST + '/api/lite/admin/settings/fbm/types',
      tokens: getState().auth.tokenData,
      callback: (res) => {
        if (res.success) {
          dispatch(receiveGetAdminSubtypesFbo(res));
        } else {
          dispatch(errorGetAdminWarehouse('Ошибка получения типов'));
        }
      },
      error: (err) => {
        dispatch(errorGetAdminSubtypesFbo(err));
      },
    });
  };
};
const requestGetAdminSubtypesFbo = () => {
  return {
    type: A.REQUEST_GET_ADMIN_SUBTYPES_FBO,
  };
};

const receiveGetAdminSubtypesFbo = (data) => {
  return {
    type: A.RECEIVE_GET_ADMIN_SUBTYPES_FBO,
    data,
  };
};

const errorGetAdminSubtypesFbo = (err) => {
  return {
    type: A.ERROR_GET_ADMIN_SUBTYPES_FBO,
    err,
  };
};

export const fetchPostSubtypesFbo = (data) => {
  return (dispatch, getState) => {
    dispatch(requestPostAdminSubtypesFbo());
    return new Promise((resolve, reject) => {
      apiPost({
        url: `${HOST}/api/lite/admin/settings/fbm/types`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receivePostAdminSubtypesFbo());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorPostAdminSubtypesFbo(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorPostAdminSubtypesFbo(err));
          reject(err);
        },
      });
    });
  };
};
const requestPostAdminSubtypesFbo = () => {
  return {
    type: A.REQUEST_POST_ADMIN_SUBTYPES_FBO,
  };
};
const receivePostAdminSubtypesFbo = (data) => {
  return {
    type: A.RECEIVE_POST_ADMIN_SUBTYPES_FBO,
    data,
  };
};
const errorPostAdminSubtypesFbo = (err) => {
  return {
    type: A.ERROR_POST_ADMIN_SUBTYPES_FBO,
    err,
  };
};

export const fetchDeleteSubtypesFbo = (data) => {
  return (dispatch, getState) => {
    dispatch(requestDeleteSubtypesFbo());
    return new Promise((resolve, reject) => {
      apiDelete({
        url: `${HOST}/api/lite/admin/settings/fbm/types`,
        body: data,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveDeleteSubtypesFbo());
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorDeleteSubtypesFbo(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorDeleteSubtypesFbo(err));
          reject(err);
        },
      });
    });
  };
};

const requestDeleteSubtypesFbo = () => {
  return {
    type: A.REQUEST_DELETE_ADMIN_SUBTYPES_FBO,
  };
};

const receiveDeleteSubtypesFbo = (data) => {
  return {
    type: A.RECEIVE_DELETE_ADMIN_SUBTYPES_FBO,
    data,
  };
};

const errorDeleteSubtypesFbo = (err) => {
  return {
    type: A.ERROR_DELETE_ADMIN_SUBTYPES_FBO,
    err,
  };
};
